export const FETCH_COMMISSION_SPLITS = 'FETCH_COMMISSION_SPLITS';
export const UPDATE_COMMISSION_SPLIT = 'UPDATE_COMMISSION_SPLIT';
